import { Button, Card, Space, Form, Input, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/TableComponent";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import UpdateProductModal from "./UpdateProductModal";

function ProductTable() {
  const [form] = Form.useForm();
  const [searchVisible, setSearchVisible] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [confirmDeleteLoading, setConfirmDeleteLoading] = useState(false);

  const columns = [
    {
      title: "Product Name",
      dataIndex: "product_name",
    },
    {
      title: "Price",
      dataIndex: "price",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Subcategory",
      dataIndex: "subcategory",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
    },
    {
      title: "Updated By",
      dataIndex: "updated_by",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Space>
            <Button size="small" onClick={() => editRecord(record)}>
              <EditOutlined />
            </Button>
            <Button
              size="small"
              onClick={() => {
                setSelectedRecord(record);
                setShowDelete(true);
              }}
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const [messageApi, contextHolder] = message.useMessage();
  const [responseData, getRequest] = useApi(
    `/config/product?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [deleteResponse, deleteRequest] = useApi();
  const [tableData, setTableData] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.error && !deleteResponse.isLoading) {
      setConfirmDeleteLoading(false);
      setSelectedRecord(null);
      setShowDelete(false);
      messageApi.open({
        type: "error",
        content: "Error deleting product",
      });
    } else if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      setConfirmDeleteLoading(false);
      setSelectedRecord(null);
      setShowDelete(false);
      messageApi.open({
        type: "success",
        content: "Product deleted successfully",
      });
    }
  }, [deleteResponse]);

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const handleEditProduct = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
      setCurrentPage(1);
    }
  };

  const deleteOk = (record) => {
    setConfirmDeleteLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/config/product/${record.id}`);
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    setCurrentPage(1);
    let url = `/config/product?pageNumber=1`;

    if (values.product_name) {
      url += `&product_name=${encodeURIComponent(values.product_name)}`;
    }

    getRequest(null, API_METHODS.GET, url);
  };

  const handleReset = () => {
    form.resetFields();
    setCurrentPage(1);
    getRequest(null, API_METHODS.GET, `/config/product?pageNumber=1`);
  };

  const onPaginationChange = (page) => {
    const values = form.getFieldsValue();
    let url = `/config/product?pageNumber=${page.current}`;

    if (values.product_name) {
      url += `&product_name=${encodeURIComponent(values.product_name)}`;
    }

    getRequest(null, API_METHODS.GET, url);
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Products"
      extra={
        <>
          <Button
            onClick={() => setSearchVisible(!searchVisible)}
            style={{ marginRight: 8 }}
          >
            {searchVisible ? "Hide Search" : "Search"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              navigate("/portal/setting/product/add");
            }}
          >
            Add Product
          </Button>
        </>
      }
    >
      {contextHolder}

      {searchVisible && (
        <div
          style={{
            padding: "16px",
            background: "#f5f5f5",
            marginBottom: "16px",
            borderRadius: "6px",
          }}
        >
          <Form form={form} layout="inline">
            <Form.Item name="product_name" label="Product Name">
              <Input
                placeholder="Search by product name"
                style={{ width: 200 }}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSearch}>
                Search
              </Button>
              <Button onClick={handleReset} style={{ marginLeft: 8 }}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}

      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visibleEdit && (
        <UpdateProductModal
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditProduct}
        />
      )}

      {showDelete && (
        <Modal
          title="Delete Product"
          open={showDelete}
          onOk={() => deleteOk(selectedRecord)}
          okText="Yes"
          okButtonProps={{
            loading: confirmDeleteLoading,
          }}
          onCancel={() => setShowDelete(false)}
        >
          Are you sure to delete <b>{selectedRecord?.product_name}?</b>
        </Modal>
      )}
    </Card>
  );
}

export default ProductTable;
